const requireRouter = require.context('@/router/human', false, /^(?!\.\/index).*\.js$/)
let routers = []

requireRouter.keys().forEach(fileName => {
  routers = [...routers, ...requireRouter(fileName).default]
})

export default routers



// WEBPACK FOOTER //
// ./src/utils/human.js